import api from "../../../shared/services/api";
import { AppStatus } from "../models/app-status.model";

export const fetchAppStatus = async () => {
  const response = await api.get<AppStatus[]>("/appStatus/list");
  return response.data;
};

export const fetchActiveAppStatus = async () => {
  const response = await api.get<AppStatus>(`/appStatus/activeAppStatus`);
  return response.data;
};

export const createAppStatus = async (appStatusReq: AppStatus): Promise<void> => {
  const result = await api.post(`/appStatus`, appStatusReq);
  return result.data;
}

export const editAppStatus = async (appStatusReq: AppStatus): Promise<void> => {
  const result = await api.put(`/appStatus`, appStatusReq);
  return result.data;
}

export const deleteAppStatus = async (appStatusReq: string): Promise<void> => {
  const result = await api.delete(`/appStatus/${appStatusReq}`);
  return result.data;
}
